import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';
import {
    Table,Col, Row, Card, CardBody,
    CardTitle, Button, Form, FormGroup, Label, Input, Modal
} from 'reactstrap';
import Parametri from '../../parametri';

import FormattaImportoVideo from '../FormattaImportoVideo.js';
import FormattaImportoDb from '../FormattaImportoDb.js';

import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';
import FinestraDialogo from '../FinestraDialogo.js';
import JsonOrarioEditor from '../../jsonOrarioEditor.js';

import Interrogativo from '../../immagini/interrogativo-azzurro.png';

import {isNumeroValido, isInteroPositivo} from  '../../funzioni.js';

const STATO_INDEFINITO = 0;
const STATO_INSERISCI = 1;
const STATO_MEMORIZZAZIONE = 2;//utilizzato per eseguire le operazioni di inserimento/modifica/eliminazione record
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_OPERAZIONE_FALLITA = 4;
const STATO_RICERCA_DATI = 5;//utilizzato nel caso modifica e cancella quando vado a ricercare i dati per popolare i campi della scheda
const STATO_RICERCA_DATI_CORRETTA = 6;//utilizzato a valle della ricerca dati record in caso di modifica o cancellazione di un record

function FormGridFormRow(props) {
    
    const SEPARATORE_CLASSI = '#';

    const [operazione,setOperazione] = useState('');
    const [variazioneCampi,setVariazioneCampi]=useState(0);
    const [flagAttivaModaleAbbNonCancellabile, setFlagAttivaModaleAbbNonCancellabile] = useState(0);
    const [flagAttivaModaleAbbNonModificabile, setFlagAttivaModaleAbbNonModificabile] = useState(0);
    const [flagAttivaModaleAbbNonInseribile, setFlagAttivaModaleAbbNonInseribile] = useState(0);
    const [flagAttivaModaleInserisciNome, setFlagAttivaModaleInserisciNome] = useState(0);
    const [flagAttivaModaleImponibileErrato, setFlagAttivaModaleImponibileErrato] = useState(0);
    const [flagAttivaModaleIvaErrata, setFlagAttivaModaleIvaErrata] = useState(0);
    const [flagAttivaModaleImportoModificato, setFlagAttivaModaleImportoModificato] = useState(0);
    const [flagAttivaModaleInfoBuoni, setFlagAttivaModaleInfoBuoni] = useState(0);
    const [flagAttivaModaleAccessi, setFlagAttivaModaleAccessi] = useState(0);
    const [modaleClasseAbbonamento, setModaleClasseAbbonamento] = useState(false);
    const [modaleAcquistabile, setModaleAcquistabile] = useState(false);
    const [modaleOrario, setModaleOrario] = useState(false);
    

    /*
        accessor: 'NOMECORSO' tendina
        accessor: 'DESCRIZIONE'
        accessor: 'NOME'
        accessor: 'IMPORTO'
        accessor: 'PERIODICITA' tendina fissa
    */

    const nome   = useRef();    
    const importo   = useRef();
    const durata   = useRef();
    const accessi  = useRef();
    const avviso  = useRef();
    const iva   = useRef();
    //const periodicita   = useRef();

    const [classiAbbonamento, setClassiAbbonamento] = useState([]);
    const [classiSuggerite, setClassiSuggerite] = useState([]);

    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);

    const [error,setError]=useState('');
    //const [risultatoServer,setRisultatoServer]=useState('');

    //const [risultatoServerDatiCorso,setRisultatoServerDatiCorso]=useState('');

    //const [insPeriodicitaEdi,setInsPeriodicitaEdi]=useState('');
    const [insUnitaDurataEdi,setInsUnitaDurataEdi]=useState(0);

    /*let nomeDefault = "";
    let importoDefault  = "";
    let periodicitaDefault  = "";*/

    const [nomeDefault,setNomeDefault]=useState('');
    const [importoDefault,setImportoDefault]=useState('');
    const [durataDefault,setDurataDefault]=useState('');
    const [avvisoDefault,setAvvisoDefault]=useState(0);

    const [accessiDefault,setAccessiDefault]=useState('');

    //const [ivaDefault,setIvaDefault]=useState('');
    //const [periodicitaDefault,setPeriodicitaDefault]=useState('');

    const [flagArchiviato,setFlagArchiviato]=useState(0);
    const [numeroSottoscrizioni, setNumeroSottoscrizioni]=useState(0);
    const [impostazioneModificaImporto, setImpostazioneModificaImporto]=useState(0);

    const [disabilitaBottoni,setDisabilitaBottoni]= useState(false);
    const [loading,setLoading]= useState(false);

    const [copiaCampo,setCopiaCampo]= useState(true);
    //let periodicitaPossibili=["Nessuna","Giornaliero","Settimanale","Quindicinale","Mensile","Bimestrale","Trimestrale","Quadrimestrale","Semestrale","Annuale"];

    const [unitaDurataPossibili,setUnitaDurataPossibili]=useState([]);

    const [termineRicercaDati,setTermineRicercaDati]=useState(0);

    const [unitaAttuale,setUnitaAttuale]=useState('');

    const [rate, setRate] = useState([]);
    const [importoTotale,setImportoTotale]=useState('');
    const [json_rate, setJsonRate] = useState([]); // attenzione: per ragioni di copia da altro codice, si chiama json_rate e non jsonRate
    const [jsonOrario, setJsonOrario] = useState([]);
    const [acquistabile, setAcquistabile] = useState(1);

    // Calcolo dell'importo da pagare subito
    const importoRate = rate.reduce((acc, r) => acc + parseFloat(r.importo || 0), 0);
    const importoSubito = Math.max(importoTotale - importoRate, 0); 
    const erroreImporto = (importoTotale-importoRate) < 0;   

    useEffect(() => {
        setStatoPagina(STATO_INSERISCI);
        setCopiaCampo(true);
        ricercaClassiAbbonamento();
        //setInsPeriodicitaEdi("Annuale");//dafault utile in inesrimento se l'utente non sceglie nulla
    },[]);

    // Effetto per aggiornare json_rate e gestire l'errore se l'importoSubito è negativo
    useEffect(() => {
        setJsonRate(rate.map(r => ({
            importo: parseFloat(r.importo),
            intervallo: parseInt(r.intervallo),
            data: r.data,
            unita: r.unita
        })));
        
    }, [rate, importoSubito]);

    useEffect(() => {
        if(termineRicercaDati === 1){
            setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
        }
    },[termineRicercaDati]);

    // Sincronizzo il campo "classe" con il campo "nome" finché copiaCampo è true
    useEffect(() => {
        if (copiaCampo && props.ope !== 'modifica') {
            if ((nomeDefault || '').trim() === '') {
                setClassiAbbonamento([]);
            } else {
                setClassiAbbonamento([nomeDefault.trim()]);
            }
        }
    }, [nomeDefault, copiaCampo, props.ope]);

    useEffect(() => {
        if(props.ope==='inserisci') setOperazione("abbonamentiIns");
        if(props.ope==='modifica') setOperazione("abbonamentiMod");
        if(props.ope==='cancella') setOperazione("abbonamentiCanc");

        if(props.ope==="modifica" || props.ope==="cancella"){
            //devo eseguire una fetch per popolare i campi della scheda con i dati presi da db per il record in esame:
            // parametri per inviare i dati al server:
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({op:"abbonamentiRecuperaDati",
                    id:props.id,
                    emak: props.emak,
                    sessionId:props.sessionId
                })
            };
            setStatoPagina(STATO_RICERCA_DATI);

            fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valoreDiRitorno) => {
                    if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                        alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                    }
                    if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                    if(valoreDiRitorno.risultatoOperazione===1){
//console.log(valoreDiRitorno.risultatoRitorno[0]);
                    //setInsPeriodicitaEdi(valoreDiRitorno.risultatoRitorno[0].PERIODICITA);
                    setNomeDefault(valoreDiRitorno.risultatoRitorno[0].NOME);
                    setClassiAbbonamento(
                        splitClassiAbbonamento(valoreDiRitorno.risultatoRitorno[0].CLASSE_ABBONAMENTO)
                    );
                    setImportoDefault(valoreDiRitorno.risultatoRitorno[0].IMPORTO);
                    setImportoTotale(valoreDiRitorno.risultatoRitorno[0].IMPORTO);
                    //setIvaDefault(valoreDiRitorno.risultatoRitorno[0].IVA);
                    //setPeriodicitaDefault(valoreDiRitorno.risultatoRitorno[0].PERIODICITA);
                    setFlagArchiviato(parseInt(valoreDiRitorno.risultatoRitorno[0].FLAG_ARCHIVIATO));

                    setDurataDefault(valoreDiRitorno.risultatoRitorno[0].DURATA_PREDEFINITA);
                    setAccessiDefault(valoreDiRitorno.risultatoRitorno[0].ACCESSI);
                    setAvvisoDefault(valoreDiRitorno.risultatoRitorno[0].GIORNI_AVVISO_SCADENZA);
                    setInsUnitaDurataEdi(valoreDiRitorno.risultatoRitorno[0].DURATA_PREDEFINITA_UNITA_MISURA);
                    
                    ricercaUnitaMisura(valoreDiRitorno.risultatoRitorno[0].DURATA_PREDEFINITA_UNITA_MISURA);

                    if (valoreDiRitorno.risultatoRitorno[0].JSON_RATE) {
                        console.log("CONVERSIONE", valoreDiRitorno.risultatoRitorno[0].JSON_RATE)
                        /* conversione necessaria: 
                        dal backend arriva il JSON_RATE fatto ad esempio così: 
                            [{ importo: 30.5, data:"", intervallo: 10, unita: "giorni" }]
                        oppure
                            [{ importo: 30.5, data:"2025-07-01", intervallo: 1, unita: "data" }]
                        Invece nel frontend, ogni rata è un oggetto come:
                        {
                            importo: "30.5",         // stringa
                            data: "",                // stringa
                            intervallo: "10",        // stringa
                            unita: "giorni"          // stringa (già a posto)
                        }
                        Quindi serve questa conversione 
                        */

                        const local_json_rate = JSON.parse(valoreDiRitorno.risultatoRitorno[0].JSON_RATE);                       
                        const local_rate = local_json_rate.map(rata => ({
                            importo: rata.importo.toString(),
                            intervallo: rata.intervallo.toString(),
                            data: rata.data,
                            unita: rata.unita
                        }));
                        setJsonRate(local_json_rate);
                        setRate(local_rate);

                        setJsonOrario(JSON.parse(valoreDiRitorno?.risultatoRitorno?.[0]?.JSON_ORARIO ?? []));
                        setAcquistabile(valoreDiRitorno.risultatoRitorno[0].ACQUISTABILE);

                    };

                    //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                    }
                    },
                (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            ); 
        } else {
            ricercaUnitaMisura(0);
            //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
        }
    },[props.ope]);

    function aggiungiClasse() {
        setCopiaCampo(false);
        setClassiAbbonamento([].concat(classiAbbonamento, ['']));
        setVariazioneCampi(1);
    }

    function modificaClasse(index, valore) {
        const nuoveClassi = [].concat(classiAbbonamento);
        nuoveClassi[index] = valore;
        setClassiAbbonamento(nuoveClassi);

        if (index === 0 && props.ope !== 'modifica') {
            if (valore !== nomeDefault) setCopiaCampo(false);
        } else {
            setCopiaCampo(false);
        }

        setVariazioneCampi(1);
    }

    function rimuoviClasse(index) {
        const nuoveClassi = [].concat(classiAbbonamento);
        nuoveClassi.splice(index, 1);

        setCopiaCampo(false);
        setClassiAbbonamento(nuoveClassi);
        setVariazioneCampi(1);
    }

    function splitClassiAbbonamento(valore) {
        if (!valore || typeof valore !== 'string') return [];
        return valore
            .split(SEPARATORE_CLASSI)
            .map(function(item) { return item.trim(); })
            .filter(function(item) { return item !== ''; });
    }

    function joinClassiAbbonamento(lista) {
        if (!Array.isArray(lista)) return '';

        return lista
            .map(function(item) { return (item || '').trim(); })
            .filter(function(item) { return item !== ''; })
            .filter(function(item, index, arr) {
                return arr.findIndex(function(x) {
                    return x.toLowerCase() === item.toLowerCase();
                }) === index;
            })
            .join(SEPARATORE_CLASSI);
    }

    function nomeClasseValido(nome) {
        if (!nome) return false;
        if (nome.indexOf(SEPARATORE_CLASSI) !== -1) return false;
        return nome.trim() !== '';
    }    

    function isInt(n) {
        return n % 1 === 0;
    }

    function ricercaClassiAbbonamento() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                op: "elencoClassiAbbonamenti",
                emak: props.emak,
                sessionId: props.sessionId
            })
        };

        fetch(Parametri("serverURL", props.identitaSelezionata), requestOptions)
            .then(function(risposta) { return risposta.json(); })
            .then(
                function(valoreDiRitorno) {
                    if (valoreDiRitorno.risultatoOperazione !== 1 && valoreDiRitorno.risultatoOperazione !== 2) {
                        alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                    }
                    if (valoreDiRitorno.risultatoOperazione === 2) props.setPagina(props.PAGINE.tornaLogin);
                    if (valoreDiRitorno.risultatoOperazione === 1) {
                        setClassiSuggerite(
                            (valoreDiRitorno.risultatoRitorno || []).map(function(item) {
                                return item.CLASSE_ABBONAMENTO;
                            })
                        );
                    }
                },
                function(error) {
                    console.log(error);
                }
            );
    }    

    function ricercaUnitaMisura(valoreAttuale) {
        //ricerco tutte le unità di misura del tempo possibili che mi servono per popolare la tendina:
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoUnitaTempo",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                setLoading(false);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){  
                    setUnitaDurataPossibili(valoreDiRitorno.risultatoRitorno);   

                    if(insUnitaDurataEdi === 0) setInsUnitaDurataEdi(valoreDiRitorno.risultatoRitorno[0].ID);//in inserimento, se non cambi nulla in tendina passerà il primo valore della tendina

                    if(parseInt(valoreAttuale) !== 0){
                        for (let i=0; i<valoreDiRitorno.risultatoRitorno.length ; i++) {
                            if(parseInt(valoreDiRitorno.risultatoRitorno[i].ID) === parseInt(valoreAttuale)){
                                setUnitaAttuale(valoreDiRitorno.risultatoRitorno[i].DESCRIZIONE_UNITA_TEMPO);
                                break;
                            } 
                        }
                    }
                    setTermineRicercaDati(1);
                    
                }
            },
            (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function tornaElenco() {
        props.callbackTermineModifica();
    }

    function tornaScheda() {
        setFlagAttivaModaleImportoModificato(0);
        setFlagAttivaModaleAbbNonCancellabile(0);
        setFlagAttivaModaleAbbNonModificabile(0);
        setFlagAttivaModaleAbbNonInseribile(0);
        setFlagAttivaModaleInserisciNome(0);
        setFlagAttivaModaleImponibileErrato(0);
        setFlagAttivaModaleIvaErrata(0);
        setFlagAttivaModaleInfoBuoni(0);
        setFlagAttivaModaleAccessi(0);
        setModaleClasseAbbonamento(false);
        setModaleAcquistabile(false);
        setModaleOrario(false);
    }

    function handleCambiamentoMod(event) {
        //event.preventDefault();
        setVariazioneCampi(1);
    }
   
    function fetchOperazioneServer(archivia=0,bypassaControlli=0) {

        let controlli=0;
        let durataLocale = 0;
        let accessiLocale = -1;
        let avvisoLocale = 0;

        if (archivia==1) {
            if (!window.confirm("Confermi archiviazione di questo abbonamento? Verrà messo in archivio e non sarà sottoscrivibile")) return;
        }

        //cancello comunque;
        if(props.ope!=='cancella' && bypassaControlli===0){
            if(nomeDefault=== ''){
                controlli = 1;
                setFlagAttivaModaleInserisciNome(1);
            }
            if(isNaN(FormattaImportoDb(importo.current.value))){
                controlli = 1;
                setFlagAttivaModaleImponibileErrato(1);
            }

            // controlli sulle classi di abbonamento
            const classiPulite = classiAbbonamento
                .map(function(item) { return (item || '').trim(); })
                .filter(function(item) { return item !== ''; });

            if (classiPulite.length === 0) {
                alert("Indicare almeno una classe abbonamento");
                controlli = 1;
                setDisabilitaBottoni(false);
            }
            for (let i = 0; i < classiPulite.length; i++) {
                if (classiPulite[i].indexOf(SEPARATORE_CLASSI) !== -1) {
                    alert("Il carattere " + SEPARATORE_CLASSI + " non può essere usato nel nome della classe");
                    controlli = 1;
                    setDisabilitaBottoni(false);
                    break;
                }
            }
            
            if(durata.current !== undefined) durataLocale = durata.current.value;

            if(isInt(durataLocale)===false){
                alert("Valorizzare la Durata con un valore intero");
                controlli = 1;
                setDisabilitaBottoni(false);
            }

            if(accessi.current !== undefined) accessiLocale = accessi.current.value;

            if(isInt(accessiLocale)===false){
                alert("Valorizzare il numero di Accessi con un valore intero");
                controlli = 1;
                setDisabilitaBottoni(false);
            }

            if(avviso.current !== undefined) avvisoLocale = avviso.current.value;

            if(isInt(avvisoLocale)===false){
                alert("Valorizzare i Giorni di Preavviso Scadenza Abbonamento per gli iscritti con un valore intero");
                controlli = 1;
                setDisabilitaBottoni(false);
            }

            // Controlla importo totale
            const imp = parseFloat(importoTotale);
            if (isNaN(imp) || !isFinite(imp) || imp < 0) {
                alert("L'importo totale non è valido.");
                controlli = 1;
                setDisabilitaBottoni(false);
            }
  
            rate.forEach((rata, index) => {
                const impRata = parseFloat(rata.importo?.toString().replace(",", "."));
                if (
                isNaN(impRata) ||
                !isFinite(impRata) ||
                impRata <= 0
                ) {
                    alert("L'importo della rata "+(index + 1)+" non è valido");
                    controlli = 1;
                    setDisabilitaBottoni(false);
                }

                const intervalloRaw = rata.intervallo;
                const intervallo = Number(intervalloRaw);

                if (
                intervalloRaw === "" ||
                isNaN(intervallo) ||
                !Number.isInteger(intervallo) ||
                intervallo < 0
                ) {
                    alert("L'intervallo della rata "+(index + 1)+" non è valido");
                    controlli = 1;
                    setDisabilitaBottoni(false);
                }
                
            });  
            
            // controllo somma importi rate, che non sia superiore all'importo totale
            if (erroreImporto) {
                alert("La somma delle rate è superiore all'importo totale");
                controlli = 1;
                setDisabilitaBottoni(false);
            }
        }

        if(controlli===0){

            //invio l'azione da fare sul server (aggiungi/togli) e l'elemento in esame al server che mi ritornerà l'elenco aggiornato
        
            if(props.ope==='modifica' && variazioneCampi===0 && archivia===0){
                //in realtà non e stata fatta alcuna variazione nei campi originali per cui torno ad elenco:
                tornaElenco(); 
            }else{
                // parametri per inviare i dati al server:
                setLoading(true);

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: props.ope !=='cancella' ? 
                        JSON.stringify({op:operazione,
                        nome:nomeDefault,
                        classe: joinClassiAbbonamento(classiAbbonamento),
                        archivia:archivia,
                        importo:FormattaImportoDb(importo.current.value),
                        importoModificato:importoDefault==importoTotale?0:1,
                        impostazioneModificaImporto:impostazioneModificaImporto,
                        //periodicita:insPeriodicitaEdi,
                        durata:durataLocale,
                        accessi:accessiLocale,
                        avviso:avvisoLocale,
                        unitaDurata:insUnitaDurataEdi,
                        idElemento:props.id,
                        json_rate:json_rate,
                        jsonOrario:jsonOrario,
                        acquistabile:acquistabile,
                        emak: props.emak,
                        sessionId:props.sessionId})
                        : 
                        JSON.stringify({op:operazione,
                        archivia:archivia,
                        archiviato:flagArchiviato,
                        idElemento:props.id,
                        emak: props.emak,
                        sessionId:props.sessionId})
                };
            
                // qui faccio la chiamata alla pagina sul server, quindi ne leggo la risposta che io trasformo in oggetto json 
                // con .json() ottenendo "valore_di_ritorno": in questo oggetto json ho "risultato_ritorno" che metto nella 
                // variabile di stato "risultato_server"
                //setStatoPagina(STATO_MEMORIZZAZIONE);

                fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                    .then(risposta => risposta.json())
                    .then(
                    (valoreDiRitorno) => {
                        setLoading(false);
                        if(valoreDiRitorno.risultatoOperazione===1) tornaElenco();
                        if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                        if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                            if(valoreDiRitorno.mess !== undefined){
                                if(valoreDiRitorno.mess.indexOf("Abb non cancellabile: presente in abbonati") !== -1){
                                    //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                               
                                    setFlagAttivaModaleAbbNonCancellabile(1);
                                } 
                                if(valoreDiRitorno.mess.indexOf("Abb non modificabile: presente altro record uguale") !== -1){
                                    //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                                
                                    setFlagAttivaModaleAbbNonModificabile(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("Abb non inseribile: presente altro record uguale") !== -1){
                                    //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                               
                                    setFlagAttivaModaleAbbNonInseribile(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("Nome non valorizzato") !== -1){
                                    //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                                  
                                    setFlagAttivaModaleInserisciNome(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("Importo errato") !== -1){
                                    //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                                  
                                    setFlagAttivaModaleImponibileErrato(1);
                                }

                                if(valoreDiRitorno.mess=="modifica importo su abb sottoscritto"){
                                    setFlagAttivaModaleImportoModificato(1);
                                    setNumeroSottoscrizioni(valoreDiRitorno.sottoscrizioni);
                                }
                                /*if(valoreDiRitorno.mess.indexOf("Iva errata") !== -1){
                                    //setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                                    setModaleIvaErrata(true);
                                    setFlagAttivaModaleIvaErrata(1);
                                }*/
                            }else{
                                //altrimenti vado in errore generico
                                setStatoPagina(STATO_OPERAZIONE_FALLITA);
                            }
                        }
                    },
                    (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
                );
            }
        }
    }
    
    // Aggiunge una nuova rata
    const aggiungiRata = () => {
        const oggi = new Date().toISOString().split("T")[0];
        setRate([...rate, { importo: "0", data: oggi, intervallo: "1", unita: "data" }]);
    };

    // Rimuove una rata
    const rimuoviRata = (index) => {
        const nuoveRate = [...rate];
        nuoveRate.splice(index, 1);
        setRate(nuoveRate);
    };

    // Modifica una rata esistente
    const aggiornaRata = (index, campo, valore) => {
        const nuoveRate = [...rate];
        nuoveRate[index][campo] = valore.replace(",", ".");
        setRate(nuoveRate);
    };
    
    const dt = new Date();
    dt.setDate(dt.getDate() - 1);
    var dg = dt.getDate();
    var dm = dt.getMonth()+1;
    var da = dt.getFullYear();
    const dataIeri = dg+"/"+dm+"/"+da;    

    //JSON.stringify(risultatoServer)
        return (
            <Fragment>
         
                {/*eccola {props.sessionId}*/}
            
                {statoPagina === STATO_MEMORIZZAZIONE ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}
                {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1Abb {error.message}</div> :""}
                {statoPagina === STATO_OPERAZIONE_FALLITA ? <div>Errore per operazione errata</div> :""}
                {statoPagina === STATO_RICERCA_DATI ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
                </div>
                </div> :""}

                {statoPagina === STATO_RICERCA_DATI_CORRETTA ?
                <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>

                    {flagAttivaModaleImportoModificato===1 ?
                        <Modale 
                        titolo="Richiesta conferma"
                        flagErrore={true}
                        contenuto={
                            <div>
                                Hai modificato l'importo su un abbonamento che è stato già sottoscritto {numeroSottoscrizioni} {numeroSottoscrizioni==1?"volta":"volte"}. Scegli cosa fare:<br/><br/>
                                <div style={{textAlign:'left'}}>
                                    <Input className="ml-2 mt-2" type="checkbox" checked={impostazioneModificaImporto === 1} onInput={(e)=>{setImpostazioneModificaImporto(1);}}/>  
                                    <Label className="ml-4 mt-1">
                                        mantieni l'importo precedente di {FormattaImportoVideo(importoDefault,1)} euro a chi ha sottoscritto finora questo abbonamento 
                                        e applica il nuovo importo di {importo.current.value} euro <b>a chi lo sottoscriverà in futuro</b>.
                                        Per fare questo, il nome dell'abbonamento finora sottoscritto cambierà in "{nomeDefault} fino al {dataIeri}".
                                    </Label>

                                    {/*<br/>

                                    <Input className="ml-2 mt-2" type="checkbox" onInput={(e)=>{setImpostazioneModificaImporto(2);}}/>  
                                    <Label className="ml-4 mt-1">
                                        mantieni l'importo precedente di {FormattaImportoVideo(importoDefault,1)} euro a chi ha sottoscritto finora questo abbonamento 
                                        e applica il nuovo importo di {importo.current.value} euro <b>solo a chi lo sottoscriverà in futuro</b>.
                                        Chi lo ha già sottoscritto continuerà ad avere il vecchio importo anche nei prossimi rinnovi.
                                        Per fare questo, il nome dell'abbonamento finora sottoscritto cambierà in "{nomeDefault} fino al {dataIeri}".
                                    </Label>*/}

                                    <br/>

                                    <Input className="ml-2 mt-2" type="checkbox" checked={impostazioneModificaImporto === 3} onInput={(e)=>{setImpostazioneModificaImporto(3);}}/>  
                                    <Label className="ml-4 mt-1">
                                        l'importo precedente di {FormattaImportoVideo(importoDefault,1)} euro era sbagliato, quindi modifica l'importo e 
                                        assegna {importo.current.value} euro <b>a tutti</b> quelli che hanno sottoscritto questo abbonamento in passato.
                                    </Label>
                                </div>

                            </div>
                        }
                        bottoni={[
                            {
                                "etichetta":"Conferma",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);fetchOperazioneServer()}
                            },
                            {
                                "etichetta":"Annulla",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""} 

                    {flagAttivaModaleInserisciNome===1 ?
                        <Modale 
                        titolo="Richiesta nome"
                        flagErrore={true}
                        contenuto={<div>Non è stato indicato il nome, che è necessario</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""} 

                    {flagAttivaModaleAbbNonCancellabile=== 1 ?
                        <Modale 
                        titolo="Informativa archiviazione abbonamento"
                        flagErrore={true}
                        contenuto={<div>L'abbonamento selezionato risulta associato ad uno o più abbonati, per questo non si può cancellare, ma si può archiviare. 
                        Vuoi archiviarlo? Se sì, verrà tolto dagli abbonamenti disponibili e comparirà solo premendo il bottone 'visualizza abbonamenti archiviati'</div>}
                        bottoni={[
                            {
                                "etichetta":"Archivia",
                                "tipo":"danger",
                                callback:() => {setDisabilitaBottoni(false);fetchOperazioneServer(1)}
                            },   
                            {
                                "etichetta":"Annulla",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}
                    {flagAttivaModaleAbbNonModificabile=== 1 ?
                        <Modale 
                        titolo="Informativa abbonamento non modificabile"
                        flagErrore={true}
                        contenuto={<div>Il nome dell'abbonamento non è modificabile in {nome.current.value} poichè è già presente un abbonamento con lo stesso nome</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}
                    {flagAttivaModaleAbbNonInseribile=== 1 ?
                        <Modale 
                        titolo="Informativa abbonamento non inseribile"
                        flagErrore={true}
                        contenuto={<div>L'abbonamento {nome.current.value} non è inseribile in poichè è già presente un abbonamento con lo stesso nome</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}

                    {flagAttivaModaleImponibileErrato=== 1 ?
                        <Modale 
                        titolo="Informativa imponibile errato"
                        flagErrore={true}
                        contenuto={<div>L'importo inserito non è un numero: completare il campo con un valore numerico</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}

                    {flagAttivaModaleIvaErrata=== 1 ?
                        <Modale 
                        titolo="Informativa iva errata"
                        flagErrore={true}
                        contenuto={<div>L'importo inserito per l'iva non è un numero: completare il campo con un valore numerico</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}
                    {flagAttivaModaleInfoBuoni=== 1 ?
                        <Modale 
                        titolo="Informativa gestione buoni abbonamento"
                        flagErrore={true}
                        contenuto={<div>Per inserire un Abbonamento Gratuito, un Abbonamento 'Buono Regalo' o simili è possibile valorizzare l'importo a 0</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}
                    {modaleClasseAbbonamento === true ?
                        <Modale 
                        titolo="Informativa campo Classe Abbonamento"
                        flagErrore={true}
                        contenuto={<div>
                            Le classi abbonamento permettono di riunire diversi abbonamenti in uno o più gruppi.
                            Un abbonamento può appartenere a più classi contemporaneamente.
                            Ad esempio uno stesso abbonamento può appartenere sia alla classe <b>Sala Pesi</b> sia alla classe <b>Open</b>.
                            Questo sarà utile ad esempio nella <b>Registrazione Manuale Accessi</b>, dove indicando una classe si otterrà l'elenco di tutti gli iscritti agli abbonamenti che appartengono a quella classe.
                            Oppure nelle <b>Prenotazioni</b>, dove si potrà vincolare la possibilità di prenotazione al possesso di un abbonamento appartenente a una determinata classe.
                        </div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}
                    {modaleAcquistabile === true ?
                        <Modale 
                        titolo="Informativa campo Acquistabile"
                        flagErrore={true}
                        contenuto={<div>Se l'installazione prevede l'acquisto di abbonamenti da parte degli iscritti, usando l'applicazione sul loro telefono, questa impostazione definisce quali abbonamenti sono acquistabili.</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}
                    {modaleOrario === true ?
                        <Modale 
                        titolo="Informativa campo Orario"
                        flagErrore={true}
                        contenuto={<div>Se l'installazione prevede il controllo accessi con orario sugli abbonamenti, l'iscritto che ha questo abbonamento potrà passare il varco solo negli orari indicati.</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}

                    {flagAttivaModaleAccessi=== 1 ?
                        <Modale 
                        titolo="Informativa Numero Accessi"
                        flagErrore={true}
                        contenuto={<div>Se il controllo accessi é stato attivato, è possibile indicare il valore massimo di accessi consentiti. Lasciando il campo vuoto verrà previsto un numero di accessi illimitato</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                        />
                    :""}

                    <div className="schedaSpazioCentrale">
                            {props.ope === "inserisci" ? <CardTitle>Inserimento Abbonamento</CardTitle> :""}
                            {props.ope === "modifica" ? 
                                flagArchiviato === 1 ? <CardTitle>Scheda Abbonamento Archiviato</CardTitle> : <CardTitle>Modifica Abbonamento</CardTitle>
                            :""}
                            
                            
                            
                            {/*{props.ope === "modifica" ? 
                                    <Row form><Col md={12}><FormGroup><Label>Nome Abbonamento: {nomeDefault}</Label><FormGroup></Col></Row>
                                    <Row form><Col md={12}><FormGroup><Label>Importo: {FormattaImportoVideo(importoDefault)}</Label><FormGroup></Col></Row>
                                    <Row form><Col md={12}><FormGroup><Label>Periodicità: {insPeriodicitaEdi}</Label><FormGroup></Col></Row>
                    :""}*/}

                        
                            <Clessidra loading={loading}/>
                                {props.ope === "cancella" ?
                                    <FinestraDialogo 
                                        titolo="Conferma eliminazione" 
                                        flagErrore={true}                                
                                        contenuto={<div>
                                            Confermi l'eliminazione dell'abbonamento <b>{nomeDefault}</b> ?<br/> 
                                            {flagArchiviato === 1 ?      
                                            <b>Attenzione: trattandosi di un abbonamento archiviato, procedendo con la cancellazione si andranno ad eliminare anche tutti i dati relativi agli abbonati ad esso connessi</b>
                                            :""}
                                        </div>}
                                        bottoni={[
                                            {
                                                "etichetta":"Conferma",
                                                "tipo":"primary",
                                                callback:() => {setDisabilitaBottoni(true);fetchOperazioneServer()}
                                            },
                                            {
                                                "etichetta":"Annulla",
                                                "tipo":"primary",
                                                callback: () => {tornaElenco()}
                                            }
                                        ]}
                                    />                        

                                :

                                <>
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                        <Label for="nome">Nome abbonamento*</Label>
                                        {(props.ope === "inserisci" || props.ope === "modifica") && flagArchiviato !== 1 ? (
                                            <Input
                                            maxLength={100}
                                            type="text"
                                            name="nome"
                                            id="nome"
                                            innerRef={nome}
                                            placeholder=""
                                            value={nomeDefault}
                                            onInput={(e) => {
                                                setNomeDefault(e.target.value);handleCambiamentoMod(e)  // Aggiorna il valore del campo nome
                                            }}
                                            />
                                        ) : (
                                            <Label for="nome">: {nomeDefault}</Label>
                                        )}
                                        {props.ope === "cancella" ? <Label>: {nomeDefault}</Label> : ""}
                                        </FormGroup>
                                    </Col>
                                    </Row>
                                    <Row form>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label>
                                                    Classi abbonamento
                                                    <img
                                                        src={Interrogativo}
                                                        className="interrogativo"
                                                        alt="aiuto"
                                                        onClick={() => setModaleClasseAbbonamento(true)}
                                                    />
                                                </Label>

                                                {(props.ope === "inserisci" || props.ope === "modifica") && flagArchiviato !== 1 ? (
                                                    <>
                                                        <datalist id="elencoClassiAbbonamento">
                                                            {classiSuggerite.map(function(classeSuggerita, index) {
                                                                return (
                                                                    <option key={index} value={classeSuggerita} />
                                                                );
                                                            })}
                                                        </datalist>

                                                        {classiAbbonamento.length === 0 ? (
                                                            <div style={{marginBottom:'8px'}}>
                                                                <Button
                                                                    color="success"
                                                                    type="button"
                                                                    onClick={aggiungiClasse}
                                                                >
                                                                    Aggiungi prima classe
                                                                </Button>
                                                            </div>
                                                        ) : (
                                                            classiAbbonamento.map(function(classeItem, index) {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        style={{
                                                                            display:'flex',
                                                                            gap:'8px',
                                                                            alignItems:'center',
                                                                            marginBottom:'8px'
                                                                        }}
                                                                    >
                                                                        <Input
                                                                            maxLength={100}
                                                                            type="text"
                                                                            value={classeItem}
                                                                            list="elencoClassiAbbonamento"
                                                                            placeholder={index === 0 ? "Prima classe abbonamento" : "Classe aggiuntiva"}
                                                                            onChange={(e) => modificaClasse(index, e.target.value)}
                                                                        />

                                                                        {index === classiAbbonamento.length - 1 ? (
                                                                            <Button
                                                                                color="success"
                                                                                type="button"
                                                                                onClick={aggiungiClasse}
                                                                            >
                                                                                Aggiungi
                                                                            </Button>
                                                                        ) : (
                                                                            <div style={{width:'92px'}}></div>
                                                                        )}

                                                                        <Button
                                                                            color="danger"
                                                                            type="button"
                                                                            onClick={() => rimuoviClasse(index)}
                                                                            disabled={classiAbbonamento.length === 1}
                                                                        >
                                                                            Elimina
                                                                        </Button>
                                                                    </div>
                                                                );
                                                            })
                                                        )}
                                                    </>
                                                ) : (
                                                    <Label>: {classiAbbonamento.join(', ')}</Label>
                                                )}

                                                {props.ope === "cancella" ? <Label>: {classiAbbonamento.join(', ')}</Label> : ""}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row form> 
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label for="importo">Importo<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagAttivaModaleInfoBuoni(1)}/></Label>
                                                {(props.ope === "inserisci" || props.ope === "modifica") && flagArchiviato!==1 ?
                                                    <Input maxLength={12} type="text" name="importo" id="importo"
                                                    innerRef={importo} placeholder="" defaultValue={FormattaImportoVideo(importoDefault,1)}
                                                    onInput={(e)=>{handleCambiamentoMod(e);setImportoTotale(FormattaImportoDb(e.target.value))}}/> 
                                                :""}
                                                {(props.ope === "inserisci" || props.ope === "modifica") && flagArchiviato===1 ?
                                                    <Input maxLength={12} type="text" name="importo" id="importo" readOnly
                                                    innerRef={importo} placeholder="" defaultValue={FormattaImportoVideo(importoDefault,1)}
                                                    onInput={(e)=>{handleCambiamentoMod(e);setImportoTotale(e.target.value)}}/> 
                                                :""}
                                                {props.ope === "cancella" ? <Label>: {FormattaImportoVideo(importoDefault)}</Label> : ""}
                                            </FormGroup>
                                        </Col>
                                        
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label for="accessi">Numero accessi<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagAttivaModaleAccessi(1)}/></Label>
                                                {(props.ope === "inserisci") && flagArchiviato!==1 ?
                                                    <Input maxLength={12} type="text" name="accessi" id="accessi"
                                                    innerRef={accessi} placeholder="" defaultValue={accessiDefault}
                                                    onInput={(e)=>{handleCambiamentoMod(e);}}/> 
                                                :""}
                                                {(props.ope === "inserisci" && flagArchiviato===1) || props.ope === "modifica" || props.ope === "cancella"?
                                                    <Input style={{backgroundColor:"#D0D0D0"}} maxLength={12} type="text" readonly value={ accessiDefault == -1 ? "Illimitato" : accessiDefault}/>
                                                :""}
                                                
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                    <Row form>

                                        <Col md={6}>
                                            <FormGroup>
                                                <Label for="durata">Durata</Label>
                                                {(props.ope === "inserisci") && flagArchiviato!==1 ?
                                                    <Input maxLength={12} type="text" name="durata" id="durata"
                                                    innerRef={durata} placeholder="" defaultValue={durataDefault}
                                                    onInput={(e)=>{handleCambiamentoMod(e);}}/> 
                                                :""}
                                                {(props.ope === "inserisci" && flagArchiviato===1) || props.ope === "modifica" ?
                                                    <Input style={{backgroundColor:"#D0D0D0"}} maxLength={12} type="text" readonly value={ durataDefault}/>
                                                :""}
                                                {props.ope === "cancella" ? <Label>: {durataDefault}</Label> : ""}
                                            </FormGroup>
                                        </Col>

                                        <Col md={6}>
                                            <FormGroup>
                                        
                            
                                            <Label for="unitaDurata">Unità di misura della durata</Label>
                                            

                                            {(props.ope === "inserisci") && flagArchiviato!==1 ?
                                                    <select defaultValue={insUnitaDurataEdi} className="form-control"  onInput={(e)=>{setInsUnitaDurataEdi(e.target.value);handleCambiamentoMod(e);}}>
                                                        {unitaDurataPossibili.map(unitaDurataPossibili =>
                                                        <option key={unitaDurataPossibili} value={unitaDurataPossibili.ID}>{unitaDurataPossibili.DESCRIZIONE_UNITA_TEMPO}</option>  
                                                        )}; 
                                                    </select>
                                            :""}

                                                
                                            {((props.ope === "inserisci" && flagArchiviato===1) || props.ope === "modifica")?     
                                                <Input style={{backgroundColor:"#D0D0D0"}} maxLength={12} type="text" readonly value={ unitaAttuale}/>
                                            :""}

                                            {props.ope === "cancella"? <Label>: {insUnitaDurataEdi}</Label> : ""}
                                            </FormGroup> 
                                        </Col>
                                    </Row> 
                                    <Row>
                                        <Col md={12}>
                                        <div style={{ marginBottom: "1em" }}>
                                            <strong>
                                                {isNumeroValido(importoSubito) ? 
                                                    <>Importo da pagare subito: € {FormattaImportoVideo(importoSubito.toFixed(2))}</>
                                                    :
                                                    <>Importi non validi</>
                                                }
                                            </strong>
                                        </div>

                                        {rate.length==0 && <span style={{color:"#FF0000"}}><b>Clicca "Aggiungi rata" per prevedere pagamenti rateali</b></span>}

                                        {erroreImporto && (
                                            <div style={{ color: "red", marginBottom: "1em" }}>
                                            ⚠️ La somma delle rate supera l’importo totale. Correggi gli importi per continuare.
                                            </div>
                                        )}

                                        {rate.length>0 &&
                                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <thead>
                                                <tr>
                                                    <th>Importo rata (€)</th>
                                                    <th>Scadenza rata</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {rate.map((rata, index) => {
                                                    const importoNonValido = !isNumeroValido(rata.importo); 
                                                    const intervalloNonValido = !isInteroPositivo(rata.intervallo);
                                                    return (
                                                        <tr key={index}>
                                                        <td>
                                                            <Input 
                                                            type="text"                                                       
                                                            value={rata.importo.replace(".", ",")}
                                                            onChange={e => {handleCambiamentoMod(e); aggiornaRata(index, "importo", e.target.value)}}
                                                            style= {{
                                                                border: importoNonValido ? '1px solid red' : undefined,
                                                                backgroundColor: importoNonValido ? "#ffe6e6" : ""
                                                            }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <div style={{display:'flex', flexDirection:'row'}}>
                                                            {rata.unita == "data" ? 
                                                                <Input
                                                                type="date"
                                                                value={rata.data}
                                                                onChange={e => {handleCambiamentoMod(e); aggiornaRata(index, "data", e.target.value)}}
                                                                />
                                                            :
                                                                <Input
                                                                type="number"
                                                                value={rata.intervallo}
                                                                onChange={e => {handleCambiamentoMod(e); aggiornaRata(index, "intervallo", e.target.value)}}
                                                                style= {{
                                                                    border: intervalloNonValido ? '1px solid red' : undefined,
                                                                    backgroundColor: intervalloNonValido ? "#ffe6e6" : ""
                                                                }}
                                                                min="1"
                                                                />
                                                            }

                                                            <select
                                                                value={rata.unita}
                                                                className="form-control"
                                                                onChange={e => {handleCambiamentoMod(e); aggiornaRata(index, "unita", e.target.value)}}
                                                            >
                                                                <option value="data">Data fissa ogni anno</option>
                                                                <option value="giorni">Giorni da inizio abbonamento</option>
                                                                <option value="mesi">Mesi da inizio abbonamento</option>
                                                            </select>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Button color="success" onClick={() => {handleCambiamentoMod(); rimuoviRata(index)}}>Rimuovi</Button>
                                                        </td>
                                                        </tr>
                                                    )
                                                })}
                                                </tbody>
                                            </table>
                                        } 

                                        <div style={{ marginTop: "1em" }}>
                                            <Button color="success" onClick={() => {handleCambiamentoMod(); aggiungiRata()}}>Aggiungi rata</Button>
                                        </div>
                                        <br/>
                                        </Col>
                                    </Row>

                                    <Row> 
                                        <Col md={6}>
                                            <FormGroup>
                                                
                                                <Label for="avviso">Giorni di preavviso su scadenza abbonamento</Label>

                                                {(props.ope === "inserisci"|| props.ope === "modifica") && flagArchiviato!==1 ?
                                                    <Input maxLength={12} type="text" name="avviso" id="avviso"
                                                    innerRef={avviso} placeholder="" defaultValue={avvisoDefault}
                                                    onInput={(e)=>{handleCambiamentoMod(e);}}/> 
                                                :<Label>: {avvisoDefault}</Label>}
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                
                                                <Label for="avviso">Acquistabile direttamente dagli iscritti<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setModaleAcquistabile(true)}/></Label>

                                                {(props.ope === "inserisci"|| props.ope === "modifica") && flagArchiviato!==1 ?
                                                    <select
                                                        className="form-control"
                                                        value={acquistabile}
                                                        onChange={(e) => {
                                                            handleCambiamentoMod(e);
                                                            setAcquistabile(e.target.value);
                                                        }}
                                                        >
                                                        <option value="1">sì</option>
                                                        <option value="0">no</option>
                                                    </select>
                                                    
                                                :<Label>: {acquistabile==1?"sì":"no"}</Label>}
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <Label for="avviso">Orario (se non specificato alcun orario, è sempre attivo)<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setModaleOrario(true)}/></Label>
                                            <JsonOrarioEditor 
                                                value={jsonOrario} 
                                                onChange={setJsonOrario} 
                                                onUpdate={(nuovoArray) => {
                                                    // console.log("Orari aggiornati:", nuovoArray);
                                                    handleCambiamentoMod();
                                                }}
                                            />
                                        </Col>
                                    </Row> 
                                  
                                </>
                                }
                                </div>

                                <div className="schedaSpazioInferiore">
                                {props.ope === "inserisci" ? <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Inserisci</Button> :""}
                                {props.ope === "modifica" && variazioneCampi === 1? 
                                    <Button disabled={disabilitaBottoni} color="warning" className="mt-2 bottoneMargineADestra" onClick={() => {
                                        /*
                                        if (importoDefault!=FormattaImportoDb(importo.current.value)) {
                                            alert("Importo modificato: default="+importoDefault+" attuale="+importo.current.value);
                                        }
                                        */
                                        setDisabilitaBottoni(true);
                                        fetchOperazioneServer();
                                    }}>Memorizza Modifiche</Button>
                                :
                                    ""
                                }
                                
                                {/*<Fragment> flagArchiviato: {flagArchiviato} </Fragment>*/}
                                
                                <Button disabled={disabilitaBottoni} color="primary" className="mt-2 bottoneMargineADestra" onClick={() => tornaElenco()} >
                                {(variazioneCampi === 1 && props.ope === "modifica") ?  <Fragment> Annulla </Fragment>: <Fragment>Torna all'elenco</Fragment>}
                                </Button>
                                {props.ope === "modifica" && flagArchiviato !== 1 ?
                                    <Button disabled={disabilitaBottoni} color="danger" className="mt-2" onClick={(e) => {fetchOperazioneServer(1)}} >
                                        <Fragment>Archivia</Fragment>
                                    </Button>
                                :""}
                                {props.ope === "modifica" && flagArchiviato === 1 ?
                                    <Button disabled={disabilitaBottoni} color="danger" className="mt-2" onClick={(e) => {fetchOperazioneServer(2)}} >
                                        <Fragment>Riporta nei Disponibili</Fragment>
                                    </Button>
                                :""}
                                </div>
                                
                </div>
                :""}
            </Fragment>
        );
}
export default FormGridFormRow;
